export function slugify(s: string) {
	const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
	const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz______';
	const p = new RegExp(a.split('').join('|'), 'g');
	const sep = '_';

	return s.toString().toLowerCase()
		.replace(/\s+/g, sep) // Replace spaces with -
		.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
		.replace(/&/g, `${sep}and${sep}`) // Replace & with 'and'
		.replace(/[^\w\-]+/g, '') // Remove all non-word characters
		.replace(/\_\_+/g, sep) // Replace multiple - with single -
		.replace(/^_+/, '') // Trim - from start of text
		.replace(/_+$/, ''); // Trim - from end of text
}
